import { formApi } from "api/TenantSlug/Form/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import FilterRequest = App.Http.Requests.FilterRequest;
import FormData = App.Data.FormData;
import GetFormsRequest = App.Http.Requests.Form.GetFormsRequest;

interface Args {
    filter?: FilterRequest;
}

export const useFormDesignSelectOptions = ({ filter }: Args = {}) => {
    const queryParams: GetFormsRequest = {
        filter: {
            sort: "name",
            ...filter,
        },
    };

    return useSelectOptions<FormData>({
        apiFunction: (payload) => formApi.index(payload),
        dataKey: "forms",
        cacheKey: "form-design-select",
        queryParams,
        mapToOption: (formDesign) => ({
            label: formDesign.name,
            value: formDesign.id?.toString() ?? "",
        }),
    });
};
